import { Component, inject } from '@angular/core';
import { PopupModule } from '@progress/kendo-angular-popup';
import { SyncQueueService, SyncState } from 'src/app/core/services/sync/sync-queue.service';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { HeaderPopupBase } from '../../classes/header-popup-base';
import { IconComponent } from '../../../icon/icon.component';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ProgressBarComponent } from '@progress/kendo-angular-progressbar';
import { SyncItemType } from 'src/models/ts/sync-item';
import { WorkspaceOfflineService } from 'src/app/core/services/workspace-offline/workspace-offline.service';

@Component({
  selector: 'bizz-header-sync',
  standalone: true,
  imports: [
    CommonModule,
    PopupModule,
    TranslatePipe,
    IconComponent,
    AsyncPipe,
    ProgressBarComponent
  ],
  templateUrl: './header-sync.component.html',
  styleUrl: './header-sync.component.scss'
})
export class HeaderSyncComponent extends HeaderPopupBase {
  public syncQueueService = inject(SyncQueueService);
  private workspaceOfflineService = inject(WorkspaceOfflineService);
  protected math = Math;
  public fetchOfflineWorkspaceStarted = false;
  public progressStyles: { [key: string]: string } = {
    color: '',
    background: '#428bca'
  };

  public startfetchingOfflineWorkspace(): void {
    this.workspaceOfflineService.fetchOfflineWorkspace();
    this.fetchOfflineWorkspaceStarted = true;
  }

  public readonly SyncItemType = SyncItemType;
  public readonly SyncState = SyncState;
}
